import './Home.css';

export default function Home() {
  return (
    <div className="home">
      <section className="hero">
        <video className="hero-video" autoPlay muted loop playsInline>
          <source src="/background.mp4" type="video/mp4" />
        </video>
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1>High Performance Computing<br />Consulting Services</h1>
          <p>
            We architect, deploy, and optimize HPC workloads on AWS —
            from simulation at scale to engineering development environments.
          </p>
          <a href="/services" className="btn-primary">Explore Our Services</a>
        </div>
      </section>

      <section className="highlights">
        <div className="highlight-card">
          <h3>Cloud HPC Architecture</h3>
          <p>Design scalable compute clusters tailored to your simulation and modeling workloads.</p>
        </div>
        <div className="highlight-card">
          <h3>Engineering Development Hub</h3>
          <p>
            Deploy and manage <a href="https://github.com/awslabs/engineering-development-hub" target="_blank" rel="noopener noreferrer">AWS EDH</a> for
            complete engineering environments with job scheduling, virtual desktops, and budget controls.
          </p>
        </div>
        <div className="highlight-card">
          <h3>Performance Optimization</h3>
          <p>Tune workloads for maximum throughput and cost efficiency across GPU and CPU instances.</p>
        </div>
      </section>
    </div>
  );
}
